import React from 'react';
import { ARTISTS_DATA, ArtistData } from './artistData';
import ArtistCard from './ArtistCard';
import './styles.css';

const ArtistList: React.FC = () => {
  const artists = [...ARTISTS_DATA].sort((a, b) => a.name.localeCompare(b.name));


  return (
    <div className="artist-list-container artist-list-container-home">
      <div className="artist-list-header">
        <h2>Featured Artists</h2>
      </div>
      
      <div className="artist-list">
        {artists.map((artist) => (
          <ArtistCard 
            key={artist.id} 
            artist={artist} 
            variant="list" 
          />
        ))}
      </div>
    </div>
  );
};

export default ArtistList;
